import { ICON_SIZES } from "src/helpers/constants";
import { EButtonKind } from "../Button/ButtonTypes";
import Modal from "../Modal/Modal";
import { MdBlock, MdClose } from "react-icons/md";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import TextList from "../TextList/TextList";
import { memo } from "react";

interface IBlockContactModal {
  onClose: () => void;
}

const BlockContactModal: React.FC<IBlockContactModal> = ({ onClose }) => {
  const { t } = useTranslation();
  return (
    <Modal
      onEscape={() => onClose()}
      className={clsx(["md:!w-[450px] md:!min-w-[450px]"])}
    >
      <Modal.Header onClose={() => onClose()} title="Bloquear perfil" />
      <Modal.Body>
        <div
          className={clsx([
            "flex",
            "flex-col",
            "gap-4",
            "w-full",
            "text-sm",
            "md:text-base",
          ])}
        >
          <div>
            ¿Estás seguro que deseas bloquear este perfil? Toma en cuenta las
            siguientes consideraciones:
          </div>
          <TextList
            items={[
              {
                text: "No puedes compartir transacciones",
              },
              {
                text: "No puedes recibir ni enviar solicitudes",
              },
              {
                text: "No puedes acceder al perfil ni a sus datos públicos",
              },
            ]}
          />
          <div className={clsx(["warning-text"])}>
            Las reglas anteriores aplican para ambos.
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer
        actions={[
          {
            kind: EButtonKind.DANGER,
            icon: <MdBlock size={ICON_SIZES.MD} />,
            onClick: () => {},
            text: t("Bloquear"),
            isLoading: false,
            disabled: false,
          },
          {
            text: t("common_buttons.close"),
            onClick: () => {
              onClose();
            },
            kind: EButtonKind.NORMAL,
            icon: <MdClose size={ICON_SIZES.MD} />,
            // disabled: isUpdatingSettings,
          },
        ]}
      />
    </Modal>
  );
};

export default memo(BlockContactModal);
